import { IModel, Model, ModelRecord } from './Model';

export interface IClinicTaskTypeModel extends IModel {
  clinicTaskTypeId: number;
  name: string;
  description: string;
  defaultDurationMins: number;
  isActive: boolean;
  isSystemGenerated: boolean;
  clinicTaskTypePublicId: string;
}

export class ClinicTaskTypeModel
  extends Model
  implements ModelRecord<IClinicTaskTypeModel>
{
  clinicTaskTypeId: number;
  name: string;
  description: string;
  defaultDurationMins: number;
  isActive: boolean;
  isSystemGenerated: boolean;
  clinicTaskTypePublicId: string;

  constructor(params?: Partial<IClinicTaskTypeModel>) {
    super(params);
    this.clinicTaskTypeId = _.defaultTo(params?.clinicTaskTypeId, 0);
    this.name = _.defaultTo(params?.name, '');
    this.description = _.defaultTo(params?.description, '');
    this.defaultDurationMins = _.defaultTo(params?.defaultDurationMins, 0);
    this.isActive = _.defaultTo(params?.isActive, true);
    this.isSystemGenerated = _.defaultTo(params?.isSystemGenerated, false);
    this.clinicTaskTypePublicId = _.defaultTo(
      params?.clinicTaskTypePublicId,
      '',
    );
  }
}
